var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2053 10.0008L14.3298 6.87636C14.5901 6.61604 14.5901 6.1939 14.3298 5.93354C14.0695 5.67323 13.6473 5.67323 13.387 5.93354L10.2625 9.05804L7.13808 5.93354C6.87776 5.67319 6.45569 5.67319 6.19526 5.93354C5.93491 6.19386 5.93491 6.61601 6.19526 6.87636L9.31972 10.0008L6.19526 13.1253C5.93491 13.3857 5.93491 13.8078 6.19526 14.0682C6.45562 14.3285 6.87772 14.3285 7.13808 14.0682L10.2625 10.9437L13.387 14.0682C13.6473 14.3285 14.0694 14.3285 14.3298 14.0682C14.5901 13.8078 14.5901 13.3857 14.3298 13.1253L11.2053 10.0008Z",
    fill: "#FC686F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 9.5,
    stroke: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.a5071a1a697e5cf49967e77d2cfffa17.svg";
export { ForwardRef as ReactComponent };